import * as nominatimApi from '@/api/nominatimApi';

const getNominatimRegionData = async ({ osmId, options }) => {
  const regionData = await nominatimApi.getNominatimRegionData({ osmId, options });
  return regionData.length > 0 ? regionData[0] : null;
};

const getNominatimRegionGeometry = async ({ osmId, options }) => {
  const regionGeometry = await nominatimApi.getNominatimRegionGeometry({ osmId, options });
  return regionGeometry;
};

export { getNominatimRegionData, getNominatimRegionGeometry };
